// Brand constants
export const BRAND = {
  name: "Top Rate",
  tagline: "Sona Do Paisa Lo",
  taglineEn: "Best Rate for Your Jewellery, Silver & Gold",
  phone: "+91 98101 07276",
  phoneRaw: "+919810107276",
  phonePrimary: "8796-432-666",
  phonePrimaryDisplay: "+91 87964 32666",
  phonePrimaryRaw: "+918796432666",
  whatsapp: "919810107276",
  whatsappMessage:
    "Namaste! Mujhe apna gold sell karna hai. Aaj ka best rate bataye. (Top Rate — Sona Do Paisa Lo)",
  cities: "Serving Gurgaon, Delhi NCR & entire North India",
};

export const BRANCHES = [
  {
    id: "jacubpura",
    name: "Jacubpura Branch",
    hindi: "जैकमपुरा शाखा",
    address:
      "Shop No. 230, Jacubpura, Chota Gurudwara, Gurugram 122001",
    phone: "+91 99732 24737",
    phoneRaw: "+919973224737",
    hours: "Mon – Sat, 10:30 AM – 8:00 PM",
    mapsQuery: "Chota Gurudwara Jacubpura Gurugram",
    embed:
      "https://www.google.com/maps?q=Chota+Gurudwara+Jacubpura+Gurugram&output=embed",
  },
  {
    id: "huda-market",
    name: "HUDA Market Branch",
    hindi: "हुडा मार्केट शाखा",
    address:
      "Shop No. 206, HUDA Market, Old Jail Road Complex, Sohna Chowk, Gurgaon 122001, Haryana",
    phone: "+91 87964 32666",
    phoneRaw: "+918796432666",
    hours: "Mon – Sun, 11:00 AM – 8:30 PM",
    mapsQuery: "HUDA Market Old Jail Road Sohna Chowk Gurgaon",
    embed:
      "https://www.google.com/maps?q=HUDA+Market+Old+Jail+Road+Sohna+Chowk+Gurgaon&output=embed",
  },
];

export const SERVICES = [
  {
    id: "instant-cash",
    icon: "Coins",
    title: "Instant Cash for Gold",
    hindi: "तुरंत नकद",
    tagline: "Cash in 30 Minutes",
    desc: "Bring any gold — jewellery, coins, biscuits or scrap. Live karat test, transparent weighing, on-spot best rate. Cash or bank transfer within 30 minutes.",
    bullets: [
      "Live XRF karat testing",
      "Digital calibrated weighing",
      "Cash or NEFT/RTGS — your choice",
    ],
  },
  {
    id: "mortgaged-gold",
    icon: "Landmark",
    title: "Mortgaged Gold Buyback",
    hindi: "गिरवी सोना खरीदें",
    tagline: "We settle with your bank",
    desc: "Gold pledged with a bank or NBFC? We buy it at the best market rate and settle the loan directly with your lender. Balance paid to you same day.",
    bullets: [
      "Works with SBI, HDFC, Muthoot, Manappuram, IIFL & more",
      "Loan closure handled end-to-end",
      "Higher payout than surrendering to lender",
    ],
  },
  {
    id: "govt-valuers",
    icon: "ShieldCheck",
    title: "Govt. Approved Gold Valuers",
    hindi: "सरकारी अनुमोदित मूल्यांकनकर्ता",
    tagline: "Certified & Trustworthy",
    desc: "Officially recognised valuers with years of licensed experience. Get an accurate valuation certificate accepted by banks, insurance and courts.",
    bullets: [
      "Registered Govt. approved valuers",
      "Valuation certificates for banks & insurance",
      "Ethical, transparent, no manipulation",
    ],
  },
];

export const TRUST_POINTS = [
  {
    icon: "Timer",
    title: "Cash in 30 Minutes",
    hindi: "30 मिनट में नकद",
    body: "Fast, professional evaluation. Walk in with gold, walk out with cash or bank transfer — no waiting games.",
  },
  {
    icon: "ScanLine",
    title: "Instant Gold Checking",
    hindi: "तुरंत जांच",
    body: "Live karat testing done in front of you. No hidden formulas, no melting-loss tricks. What you see is what you get.",
  },
  {
    icon: "BadgeCheck",
    title: "No Manipulation Policy",
    hindi: "कोई हेराफेरी नहीं",
    body: "Other dealers cut on weight, purity or use unclear formulas. We publish everything up-front — it's why customers return.",
  },
  {
    icon: "Banknote",
    title: "Cash OR Bank Transfer",
    hindi: "नकद या बैंक ट्रांसफर",
    body: "Get paid the way you want. Instant cash for small quantities, secure NEFT/RTGS for larger amounts.",
  },
  {
    icon: "MapPin",
    title: "Two Branches in Gurgaon",
    hindi: "गुड़गांव में दो शाखाएं",
    body: "Sadar Bazaar and Sapphire Mall Sec 49. Home visit available across North India on prior appointment.",
  },
  {
    icon: "Award",
    title: "Govt. Approved Valuers",
    hindi: "सरकारी अनुमोदित",
    body: "Officially licensed valuers. Certificates recognised by banks, courts and insurance companies.",
  },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1601121141418-c1caa10a2a0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBnb2xkJTIwamV3ZWxyeSUyMG9ybmFtZW50fGVufDB8fHx8MTc4Mjk2ODczNHww&ixlib=rb-4.1.0&q=85",
  rupees500:
    "https://commons.wikimedia.org/wiki/Special:FilePath/India_new_500_INR,_MG_series,_2016,_obverse.jpg?width=1200",
  biscuits:
    "https://images.unsplash.com/photo-1762463176312-1757d5125c85?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxnb2xkJTIwYmFycyUyMGJpc2N1aXRzfGVufDB8fHx8MTc4Mjk2ODczM3ww&ixlib=rb-4.1.0&q=85",
  cashHands:
    "https://images.unsplash.com/photo-1518458028785-8fbcd101ebb9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxzZWN1cmUlMjBjYXNoJTIwbW9uZXklMjBoYW5kc3xlbnwwfHx8fDE3ODI5Njg3MzR8MA&ixlib=rb-4.1.0&q=85",
  ornament1:
    "https://images.unsplash.com/photo-1651160670627-2896ddf7822f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBnb2xkJTIwamV3ZWxyeSUyMG9ybmFtZW50fGVufDB8fHx8MTc4Mjk2ODczNHww&ixlib=rb-4.1.0&q=85",
};

export const waLink = (message) => {
  const msg = encodeURIComponent(message || BRAND.whatsappMessage);
  return `https://wa.me/${BRAND.whatsapp}?text=${msg}`;
};

export const telLink = `tel:${BRAND.phoneRaw}`;
export const telLinkPrimary = `tel:${BRAND.phonePrimaryRaw}`;
